










import { PropType } from 'vue';
import { computed, defineComponent, toRefs } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
import DeviceModel from './index';

const name = 'ttam-device-model-compose';
export default defineComponent({
  name,
  components: {
    TtamDeviceModel: DeviceModel.TtamDeviceModel,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    // 错误字段map，初始化后的报错信息
    errorsMap: {
      type: Object as PropType<Record<string, string>>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData } = toRefs(props);
    const _deviceModels = computed({
      get: () => adgroupData.value.deviceModels,
      set: val => {
        emit('change', val);
      },
    });
    DeviceModel.usePropDeviceModelName({ adgroupData });
    const { isLoading } = DeviceModel.useDataSource();
    const { deviceModelOptions } = DeviceModel.usePropDeviceModelOptions({ adgroupData });
    return {
      name,
      _deviceModels,
      deviceModelOptions,
      isLoading,
    };
  },
});
